import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityProductCostsListResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useProductCosts = (enabled: boolean, productId?: number | null) => {
  return useQuery<ProfitabilityProductCostsListResponse, Error>({
    queryKey: ['profitability', 'product-costs', productId ?? 'all'],
    queryFn: () => adapter.getProductCosts(productId != null && productId > 0 ? { product_id: productId } : undefined),
    enabled,
    staleTime: 30 * 1000,
  });
};
